import { styled, Typography, Tooltip } from '@mui/material';
import { useRef } from 'react';
import { useIsOverflowing } from 'utils/hooks/useIsOverflow';

const Title = styled(Typography)(() => ({
  fontSize: '15px',
  fontWeight: 600,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}));

type ModuleTitleWithTooltipProps = {
  title: string;
};

const ModuleTitleWithTooltip = ({ title }: ModuleTitleWithTooltipProps) => {
  const titleRef = useRef<HTMLElement | null>(null);
  const { isOverflowing } = useIsOverflowing(titleRef, title, 0);

  return (
    <Tooltip title={isOverflowing && title ? title : ''} arrow placement="top" disableHoverListener={!isOverflowing || !title}>
      <Title ref={titleRef}>{title}</Title>
    </Tooltip>
  );
};

export { ModuleTitleWithTooltip };
